import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BgDeleteDocument, BgSaveDocument, DocumentsForSendType, KindType } from 'Pages/ibro'

export type BgDocumentState = {
	documentsLoading: KindType[]
}

export const bgDocumentInitialState: BgDocumentState = {
	documentsLoading: [],
}

export namespace BgDocumentNs {
	export type DownloadDocument = PayloadAction<{ id: number; filename: string }>
	export type SendDocumentToEmail = PayloadAction<{ id: number; type: DocumentsForSendType }>
	export type DocumentIsLoading = PayloadAction<KindType>
	export type SaveDocument = PayloadAction<BgSaveDocument>
	export type DeleteDocument = PayloadAction<BgDeleteDocument>
	export type SaveLimitRequestDocument = PayloadAction<BgSaveDocument>
	export type DeleteLimitRequestDocument = PayloadAction<BgDeleteDocument>
	export type DownloadTrustDocument = PayloadAction<{
		id: number
		filename: string
		request_id: number
	}>
	export type PostDocuments = PayloadAction<{ id: number; with_signed_docs?: boolean }>
}

export const bgDocumentSlice = createSlice({
	name: 'bgDocument',
	initialState: bgDocumentInitialState,
	reducers: {
		downloadDocument: (state, action: BgDocumentNs.DownloadDocument) => {},
		sendDocumentToEmail: (state, action: BgDocumentNs.SendDocumentToEmail) => {},
		addDocumentLoading: (state, action: BgDocumentNs.DocumentIsLoading) => {
			state.documentsLoading = [...state.documentsLoading, action.payload]
		},
		removeDocumentLoading: (state, action: BgDocumentNs.DocumentIsLoading) => {
			state.documentsLoading = state.documentsLoading.filter((kind) => kind !== action.payload)
		},
		saveDocument: (state, action: BgDocumentNs.SaveDocument) => {},
		deleteDocument: (state, action: BgDocumentNs.DeleteDocument) => {},
		saveLimitRequestDocument: (state, action: BgDocumentNs.SaveLimitRequestDocument) => {},
		deleteLimitRequestDocument: (state, action: BgDocumentNs.DeleteLimitRequestDocument) => {},
		downLoadGuaranteeTemplate: () => {},
		clear: (state) => {
			state.documentsLoading = []
		},
		downloadTrustDocument: (state, action: BgDocumentNs.DownloadTrustDocument) => {},
		postDocuments: (state, action: BgDocumentNs.PostDocuments) => {},
	},
})
